var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddressHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.65,
    height: 58.224,
    viewBox: "0 0 67.65 58.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0.8 0.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-916 -546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(918 548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-24",
    d: "M7.43,24.074V52.989a1,1,0,0,0,1,1H22.949a1,1,0,0,0,1-1V36.839a6.847,6.847,0,0,1,13.693,0v16.15a1,1,0,0,0,1,1h13.9a1,1,0,0,0,1-1V24.074h0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-25",
    d: "M0,22.869,30.486,0,62.058,22.869",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 4,
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressHome);
export default __webpack_public_path__ + "static/media/address-home.95cf59e3.svg";
export { ForwardRef as ReactComponent };